import { environmentConfig } from "@src/appV2/environment";

// TODO: Move this over to a deep link after GRO-1161
export function getPlacementHiringLink(placementId: string, referralCode: string) {
  return `${environmentConfig.REACT_APP_HIRING_PORTAL_URL}/placements/${placementId}?referralCode=${referralCode}`;
}
